import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//API
import ItemService from "../../../../services/inventory_appCommonService";
//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../Components/formElements/InputField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import Layout from "../../../../Layout/Layout";
import { isValidNumber } from "../../../../common/Validations";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  NUMBER_ALLOWED: "Please enter a valid number."
};

const ProductionOrderDetail = () => {
  const productionOrderNr = useSelector((state) => state.inventory.productionOrder.proNr);
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, /*setErrorFields*/] = useState([]);
  const [getByProducts, setByProducts] = useState([
    {
      id: Date.now(),
      Quantity: "",
      Component_Code: "",
      Component_Desc: "",
    },
  ]);
  const [bomTypeData, setBomTypeData] = useState([
    {
      id: Date.now(),
      Quantity: "",
      Component_Desc: "",
      UOM: "",
    },
  ]);
  const [validation, setValidation] = useState({
    Quantity: "",
    confirmedQty: "",

  });

  const [getUtilites, setUtilites] = useState([
      {
        id: Date.now(),
        Quantity: "",
        Component_Code: "",
        Component_Desc: "",
      },
    ]);

  
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const onInputChange = ({ target: { name, value } }) => {

    let error = "";

    if (name === "Quantity" && !isValidNumber(value)) {
      error = message.NUMBER_ALLOWED;
    }
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const [formInputs, setFormInputs] = useState({
    Order_Number: "",
    Quantity: "",

  });

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  const handleChangeByProducts = (id, fieldName, value) => {
    let error = "";

    if (fieldName === "Quantity" && !isValidNumber(value)) {
      error = message.NUMBER_ALLOWED;
    }
    setByProducts((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
    // Update validation with unique key per row
    if (fieldName === "Quantity") {
      setValidation((prev) => ({
        ...prev,
        [`${id}Quantity`]: error,  // <-- unique key here
      }));
    }
  };

  const loadFirstLevelData = async (page) => {

    if (productionOrderNr) {
      let obj = {
        documentNumber: productionOrderNr,
      };
      await ItemService.getProductionOrderDatails(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          setBomTypeData(item?.data[0]?.bom ?? []);
          setByProducts(item?.data[0]?.byProducts ?? []);
          setUtilites(item?.data[0]?.utilites)
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
    }
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleInputChange = (id, fieldName, value) => {
    let error = "";

    if (fieldName === "Quantity" && !isValidNumber(value)) {
      error = message.NUMBER_ALLOWED;
    }

    setBomTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );

    // Update validation with unique key per row
    if (fieldName === "Quantity") {
      setValidation((prev) => ({
        ...prev,
        [`${id}Quantity`]: error,
      }));
    }
  };

  //bank end
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Production Order Details  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
              {productionOrderNr}
            </span></h2>

            <p className="subText">
              {/* Register as a new Vehicle or Sub-Contractor with our Company */}
            </p>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PO</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Production Order </span>
                      <span className="subHeaderTitle">Production Order </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Production Order Nr"
                          name="productionOrderNr"
                          placeholder=""
                          value={formInputs?.productionOrderNr}
                          onChange={onInputChange}
                          required={true}
                          error={validation.productionOrderNr}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Material"
                          name="FG_Mat_Desc"
                          placeholder=""
                          value={formInputs?.FG_Mat_Desc}
                          onChange={onInputChange}
                          error={validation.FG_Mat_Desc}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Order Qty"
                          name="Quantity"
                          placeholder=""
                          value={formInputs?.Quantity}
                          onChange={onInputChange}
                          error={validation.Quantity}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Plant"
                          name="Plant_Code"
                          placeholder=""
                          value={formInputs?.Plant_Code}
                          onChange={onInputChange}
                          error={validation.Plant_Code}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BM</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">BOM</span>
                      <span className="subHeaderTitle">BOM Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Material Name
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          BOM Qty
                                        </p>
                                      </Col>
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          UOM
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Calc Qty
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Actual Qty
                                        </p>
                                      </Col>
                                    </Row>
                                    {
                                      Array.isArray(bomTypeData) &&
                                      bomTypeData.map((doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Component_Desc"
                                              placeholder="Material Name"
                                              value={doc.Component_Desc || ""}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "Component_Desc",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Quantity"
                                              placeholder="BOM"
                                              value={doc.Quantity || ""}
                                              error={validation[`${doc.id}Quantity`]}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value
                                                )

                                              }
                                              disabled={true}

                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="UOM"
                                              placeholder="UOM"
                                              value={doc.UOM || ""}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "UOM",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Quantity"
                                              placeholder="Cal Qty"
                                              value={doc.Quantity || ""}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value,
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="Quantity"
                                              placeholder="Actual Qty"
                                              value={doc.Quantity || ""}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                        </Row>
                                      ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">By Products</span>
                      <span className="subHeaderTitle">
                        By Products Details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Material Name
                                        </p>
                                      </Col>
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          BOM
                                        </p>
                                      </Col>
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Batch
                                        </p>
                                      </Col>
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Calc Qty
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Actual Qty
                                        </p>
                                      </Col>
                                    </Row>
                                    {getByProducts.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={2}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Component_Desc"
                                              placeholder="Material Name"
                                              value={doc.Component_Desc || ""}
                                              onChange={(e) =>
                                                handleChangeByProducts(
                                                  doc.id,
                                                  "Component_Desc",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={2}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Quantity"
                                              placeholder="BOM"
                                              value={doc.Quantity || ""}
                                              error={validation[`${doc.id}Quantity`]}
                                              onChange={(e) =>
                                                handleChangeByProducts(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={2}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Component_Code"
                                              placeholder="Batch"
                                              value={doc.Component_Code || ""}
                                              onChange={(e) =>
                                                handleChangeByProducts(
                                                  doc.id,
                                                  "Component_Code",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={2}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="Quantity"
                                              placeholder="Cal Qty"
                                              value={doc.Quantity || ""}
                                              onChange={(e) =>
                                                handleChangeByProducts(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={2}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="Quantity"
                                              placeholder="Actual Qty"
                                              value={doc.Quantity || ""}
                                              onChange={(e) =>
                                                handleChangeByProducts(
                                                  doc.id,
                                                  "Quantity",
                                                  e.target.value
                                                )
                                              }
                                              disabled={true}
                                            />
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">U</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Utilities </span>
                      <span className="subHeaderTitle">Utilities Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Electric Energy(KWh)"
                          name="electricEnergy"
                          placeholder=""
                          value={formInputs?.electricEnergy}
                          onChange={onInputChange}
                          required={true}
                          error={validation.electricEnergy}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Gas Volume"
                          name="gasVoulume"
                          placeholder=""
                          value={formInputs?.gasVoulume}
                          onChange={onInputChange}
                          error={validation.gasVoulume}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Stream Energy"
                          name="streamEnergy"
                          placeholder=""
                          value={formInputs?.streamEnergy || ""}
                          onChange={onInputChange}
                          error={validation.streamEnergy}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Man Power"
                          name="manPower"
                          placeholder=""
                          value={formInputs?.manPower || ""}
                          onChange={onInputChange}
                          error={validation.manPower}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}
             <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                  <i
                                    className={`bi ${isCardVisible2
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                      }`}
                                    onClick={toggleCardVisibility2}
                                  ></i>
                                </Col>
                                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                  <span className="iconLogo">U</span>
                                </Col>
                                <Col xs={4} md={8} lg={8}>
                                  <span className="headerTitle">Utilities</span>
                                  <span className="subHeaderTitle">
                                    Utilities Details
                                  </span>
                                </Col>
                                {/* <Col xs={4} md={2} lg={2}>
                                  <div className="d-flex justify-content-end  p-2 me-3">
                                    <button
                                      className="btnTable"
                                      onClick={addUtilites}
                                    >
                                      <i className="bi bi-plus-lg"></i> Add
                                    </button>
                                  </div>
                                </Col> */}
                              </Row>
                            </h2>
                            <div
                              // id="acc"
                              className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                                }`}
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col xs={12} md={12} lg={12}>
                                    <div className="accordion-body">
                                      <div className="d-flex-column justify-content-center">
                                        <Row>
                                          <Col xs={12}>
                                            <div className="accordion-body">
                                              <div className="d-flex-column justify-content-center">
                                                <Row className="pt-4 d-none d-lg-flex ">
                                                  <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      Utilites
                                                    </p>
                                                  </Col>
                                                  {/* <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      System Qty
                                                    </p>
                                                  </Col> */}
                                                  <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      Value
                                                    </p>
                                                  </Col>
                                                  {/* <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex">
                                                      Action
                                                    </p>
                                                  </Col> */}
                                                </Row>
                                                {getUtilites.map(
                                                  (doc, index) => (
                                                    <Row key={doc.id}>
                                                      <Col xs={12}>
                                                        <hr className="mx-4 my-0 text-color-black" />
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={2}
                                                        lg={2}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <InputField
                                                          className="inputBox mt-1"
                                                          name="utilites"
                                                          placeholder="Utilites Name"
                                                          value={doc.utilites || ""}
                                                          disabled={true}
                                                          // onChange={(e) =>
                                                          //   handleUtilites(
                                                          //     doc.id,
                                                          //     "utilites",
                                                          //     e.target.value
                                                          //   )
                                                          // }
                                                        />
                                                      </Col>
                                                      {/* <Col
                                                        xs={12}
                                                        md={2}
                                                        lg={2}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <InputField
                                                          className="inputBox mt-1"
                                                          name="systemQty"
                                                          placeholder="System Qty"
                                                          value={doc.systemQty || ""}
                                                          error={validation[`${doc.id}systemQty`]}
                                                          onChange={(e) =>
                                                            handleUtilites(
                                                              doc.id,
                                                              "systemQty",
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </Col> */}
                                                      <Col
                                                        xs={12}
                                                        md={2}
                                                        lg={2}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <InputField
                                                          className="inputBox mt-1"
                                                          name="utilitesValue"
                                                          placeholder="Value"
                                                          value={doc.utilitesValue || ""}
                                                          disabled={true}
                                                          // onChange={(e) =>
                                                          //   handleUtilites(
                                                          //     doc.id,
                                                          //     "utilitesValue",
                                                          //     e.target.value
                                                          //   )
                                                          // }
                                                        />
                                                      </Col>
                                                      {/* <Col
                                                        xs={12}
                                                        md={1}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <i
                                                          onClick={() =>
                                                            deleteUtilites(
                                                              doc.id
                                                            )
                                                          }
                                                          className="bi bi-trash text-danger fs-4"
                                                        />
                                                      </Col> */}
                                                    </Row>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default ProductionOrderDetail;
